export default __webpack_public_path__ + "04612851c6a2d6a013f5360660394edd.png";